module.exports = __webpack_public_path__ + "00a6995fe0c3212b70150f2803837bf0.png";